module.exports = __webpack_public_path__ + "static/media/noticebg.c2fa82ea.png";